export default __webpack_public_path__ + "static/media/Silverline.0d24c17a.png";